import styled from 'styled-components';
import {
  Section,
  ServicesSubItems,
} from '../services-menu/services-menu.styles';
import { FontSizes } from '../../../common/typography/typography.styles';

export const CrossSaleMenuSectionContainer = styled(Section)`
  cursor: pointer;
  padding: 8px 0 0 0;

  ${ServicesSubItems} {
    display: flex;
    flex-direction: column;
  }

  .topPart {
    display: flex;
    align-items: center;
  }

  .logo {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.colors.baseColors.grey5};
    border-radius: 4px;
    margin-left: 1.2rem;
    width: 2rem;
    height: 2rem;

    margin-right: 8px;
    svg {
      width: 16px;
      height: 13px;
    }
  }

  .productTitle {
    font-size: ${FontSizes.normal};
    font-weight: 500;
    line-height: 2rem;
    letter-spacing: 0.5px;
    margin-right: 4px;
  }

  .newPill {
    background-color: ${({ theme }) => theme.colors.baseColors.red100};
    color: ${({ theme }) => theme.colors.namedColors.white};
    font-size: ${FontSizes.small};
    font-weight: 500;
    line-height: 1.6rem;
    padding: 0 4px;
    border-radius: 2.4rem;
    margin-right: 1.2rem;
  }

  .fullScreenIcon {
    color: ${({ theme }) => theme.colors.baseColors.grey100};
    transition: color 0.2sec;
    margin-left: auto;
    margin-right: 4px;
  }

  &:hover {
    .fullScreenIcon {
      color: ${({ theme }) => theme.colors.namedColors.primary};
    }
  }

  &:active {
    .fullScreenIcon {
      color: ${({ theme }) => theme.colors.namedColors.primarySelected};
    }
  }

  .bottomPart {
    padding: 0 2rem 0 4rem;
    color: ${({ theme }) => theme.colors.baseColors.grey100};

    span {
      font-size: ${FontSizes.small};
      font-weight: 400;
      line-height: 1.6rem;
      letter-spacing: 0.5px;
    }
  }
`;
